import React from 'react';
import { T } from './NOCShared';
import { formatTime } from '../../utils/formatTime';

export default function NOCHeader({ currentTime, fullscreen, toggleFullscreen, services, incidents, onBack }) {
  const healthy = services.filter(s => s.status === 'healthy').length;
  const openInc = incidents.filter(i => i.status !== 'resolved').length;
  const critical = incidents.filter(i => i.severity === 'critical' && i.status !== 'resolved').length;

  return (
    <div className="flex items-center justify-between shrink-0" style={{ height: '42px', background: 'rgba(255,255,255,0.015)', borderBottom: `1px solid ${T.border}`, paddingLeft: 16, paddingRight: 16 }}>
      <div className="flex items-center gap-4">
        {onBack && (
          <button onClick={onBack}
            className="flex items-center gap-1 text-[10px] font-medium transition-all"
            style={{ color: T.textDim, border: `1px solid ${T.border}`, padding: '4px 8px', borderRadius: 6 }}>
            <span style={{ color: T.pink }}>&#8592;</span> Dashboard
          </button>
        )}
        <span className="text-sm font-bold tracking-[0.2em]"
          style={{ background: `linear-gradient(90deg, ${T.pink}, ${T.purple})`, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
          SYNOTI AIOps + SecOps Platform
        </span>
        <div className="flex items-center gap-3 text-[10px]" style={{ color: T.textDim }}>
          <span><span style={{ color: T.success }}>{healthy}/{services.length}</span> healthy</span>
          <span><span style={{ color: critical ? T.danger : T.success }}>{openInc}</span> open{critical ? ` (${critical}C)` : ''}</span>
        </div>
      </div>

      <div className="flex items-center gap-4">
        <div className="text-center">
          <div className="font-mono text-sm font-bold tracking-wider" style={{ color: T.textBright }}>
            {currentTime.toLocaleTimeString('en-US', { hour12: false })}
          </div>
          <div className="text-[9px] tracking-[0.15em]" style={{ color: T.textDim }}>
            {currentTime.toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' })}
          </div>
        </div>
        <button onClick={() => window.open(window.location.href, '_blank')}
          className="text-[9px] font-medium transition-all hover:opacity-80"
          style={{ background: 'rgba(255,255,255,0.03)', border: `1px solid ${T.border}`, color: T.textDim, padding: '4px 8px', borderRadius: 6 }}>
          &#8599; New Window
        </button>
        <button onClick={toggleFullscreen}
          className="text-[9px] font-medium transition-all hover:opacity-80"
          style={{ background: fullscreen ? 'rgba(239,68,68,0.2)' : 'rgba(162,70,255,0.12)', border: `1px solid ${fullscreen ? 'rgba(239,68,68,0.3)' : T.borderGlow}`, color: fullscreen ? '#f87171' : T.purple, padding: '4px 8px', borderRadius: 6 }}>
          {fullscreen ? '⛶ EXIT (Esc)' : '⛶ Fullscreen'}
        </button>
      </div>

      <div className="text-right text-[9px] tracking-[0.1em] font-medium" style={{ color: T.textDim }}>
        ALYPOD LLC | OPERATIONS CENTER
      </div>
    </div>
  );
}
